module.exports = __webpack_public_path__ + "img/1.c29a74db.png";